"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarrierHubId = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.CarrierHubId = {
    Atl: 'ATL',
    Ben: 'BEN',
    Bwi: 'BWI',
    Clt: 'CLT',
    Cvg: 'CVG',
    Dfw: 'DFW',
    Ewr: 'EWR',
    Fat: 'FAT',
    Las: 'LAS',
    Lax: 'LAX',
    Lck: 'LCK',
    Mco: 'MCO',
    Ord: 'ORD',
    Rdu: 'RDU',
    Rno: 'RNO',
    Sfo: 'SFO'
};
//# sourceMappingURL=carrier-hub-id.js.map